<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Manage Prices</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small text to="/pos/profit/report">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-row>
                    <v-text-field name="priceListSearch" v-model="search" append-icon="mdi-magnify" label="Search"
                        single-line hide-details></v-text-field>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-data-table :items-per-page="pageItems" :headers="headers" :items="priceLists"
                            :search="search">

                            <!-- action template -->
                            <template v-slot:item.action="{ item }">
                                <v-btn color="accent" text @click="openEditModal(item)">
                                    <v-icon left>mdi-pencil</v-icon> Edit Price
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                    </v-col>
                </v-row>

                <!-- Ctreate shop dialog -->
                <v-dialog v-model="editDialog" max-width="750px">
                    <v-card>
                        <v-toolbar dense color="secondary" flat>
                            <v-toolbar-title>Edit Product Price</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click.native="editDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="style-16">{{ editRecord.Name }}</span>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Buying Price"
                                            v-model="editRecord.BuyingPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Selling Price"
                                            v-model="editRecord.SellingPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field outlined dense label="Least Price"
                                            v-model="editRecord.LeastPrice"></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn color="primary" @click="updatePrices" :loading="loader">
                                            <v-icon left>mdi-content-save</v-icon> Update Price
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- end of shop modal-->
                <snackbar ref="snackbar"></snackbar>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        search: "",
        loader: false,
        pageItems: 100,
        editRecord: {},
        editDialog: false,
        headers: [
            { text: "Product Name", value: "Name" },
            { text: "Buying Price", value: "BuyingPrice" },
            { text: "Selling price", value: "SellingPrice" },
            { text: "Least Price", value: "LeastPrice" },
            { text: "Action", value: "action" }
        ],
        priceLists: []
    }),
    methods: {
        openEditModal(item) {
            this.editRecord = item;
            this.editDialog = true;
        },
        updatePrices() {
            var rowId = this.editRecord.id;
            var editedData = this.editRecord;
            var data = {
                "id": parseInt(rowId),
                "BuyingPrice": parseFloat(editedData.BuyingPrice),
                "SellingPrice": parseFloat(editedData.SellingPrice),
                "LeastPrice": parseFloat(editedData.LeastPrice)
            };

            const url = `/product-prices-update`;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.editDialog = false;
                        self.$refs.snackbar.show("Price updated successfully", "green");
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    self.loader = false;
                    self.$refs.snackbar.show(err, "red");
                });
        },
        getData() {
            const self = this;
            this.$store
                .dispatch("get", `/non-uom-price-list`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        console.log(res.ResponseData, " res");
                        self.priceLists = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        updatePrice() {

        }
    },
    created() {
        this.getData();
    }
};
</script>